import React, { useEffect, useState} from "react";
import store from "@/redux/store";
import { v4 as uuid } from "uuid";

import { BuildingOfficeIcon, CreditCardIcon, UserIcon, UsersIcon } from '@heroicons/react/20/solid'
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { Switch,Label, Field } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'

import { Detail as CustomerCompany } from "@/views/base/company/Detail";
import { useForm, SubmitHandler } from "react-hook-form"
import  {ICustomer} from "@/models/Customer";
import {FieldHolder} from "@/components/holders/FieldHolder";
import { useNavigate, Link } from "react-router-dom";

import {CogIcon} from '@heroicons/react/24/outline'
import CalenderHelperClass from '@/helpers/CalenderHelper'
import {DayWorkhourModel, DayWorkhours} from '@/models/DayWorkhours';
import {IntervalSetting} from '@/components/datetime/interval/IntervalSetting';


export function WorkHoursView({...props})  {
        let daysInWeekTmp = new DayWorkhours();
        const [daysInWeek, setDaysInWeek] = useState(daysInWeekTmp);
        const [updateKey, setUpdateKey] = useState(null);
        useEffect(() => {
            if(daysInWeek.items.length == 0) {
            let daysInWeek2 = CalenderHelperClass.getDays();
            daysInWeekTmp = new DayWorkhours();
            daysInWeek2.forEach((item, index) => {
                let workHour = new DayWorkhourModel({name:item, daynumber: (index+1) });
                daysInWeekTmp.set(workHour);
                return workHour;
            }) 
            
            setDaysInWeek(daysInWeekTmp);
            }
        });
        
        const onChangeDay=(event, item) => {
            //event.preventDefault();
            item.wholeDay = event;
            item.isWorking = event;
            daysInWeek.update( item );

            setDaysInWeek(daysInWeek);
            setUpdateKey(uuid().slice(0, 8));
            //setDaysInWeek(daysInWeekTmp);
            
            return false;
        }
        
       return (<>
       
       
          <table className="min-w-full divide-y divide-gray-300">
              <thead>
                <tr>
                  <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0 w-12">
                    Dag
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 ">
                    Beschikbaar
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
       {daysInWeek && daysInWeek.items.map((item, index) => {
         return (<tr key={index}>

           <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 capitalize">{item.name}</td>
           <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
           
    <Switch
      checked={item.wholeDay}      
      onChange={(event) => {onChangeDay(event, item)}}
      className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
    >
      <span className="sr-only">Use setting</span>
      <span
        aria-hidden="true"
        className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
      />
    </Switch>               
        {!item.isAvailable() &&
        <IntervalSetting data={item} type="day" defaultValue={item.wholeDay}/>
        
        } 
           
           
           
           </td>
           </tr>);
           })}
              </tbody>
            </table>
       
       </>);
       
}